import React from "react"
import {
  addressItem,
  addressesFullsizeContainer,
  carnetAdresseResponsiveOnly,
  editButton,
} from "../carnet-adresse.module.scss"
import PropTypes from "prop-types"
import AddressContent from "../AddressContent/address-content"
import MultiCarousel from "react-multi-carousel"
import {
  carouselArrowRight,
  carouselArrowLeft,
} from "../../../Transformers/CarouselTransformer/carousel-transformer.module.scss"
import { CustomArrow } from "../../Carousel/custom-carousel-elements-styled"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

const RenderAddresses = ({ addressesData }) => {
  const addresses = addressesData.allNodeCarnetDAdresse.edges
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 900 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 900, min: 0 },
      items: 1,
    },
  }
  return (
    <>
      <ul className={addressesFullsizeContainer}>
        {addresses.map(({ node }) => (
          <li key={node.drupal_id} className={addressItem}>
            <EditButton
              addedClass={editButton}
              link={"/node/" + node.drupal_internal__nid + "/edit"}
            />
            <AddressContent address={node} />
          </li>
        ))}
      </ul>
      <MultiCarousel
        className={carnetAdresseResponsiveOnly}
        transitionDuration={500}
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<CustomLeftArrow />}
        responsive={responsive}
        infinite={true}
        arrows={true}
        autoPlay={false}
        shouldResetAutoplay={false}
        renderButtonGroupOutside={true}
      >
        {addresses.map(({ node }) => {
          return (
            <div key={node.drupal_id} className={addressItem}>
              <EditButton
                addedClass={editButton}
                link={"/node/" + node.drupal_internal__nid + "/edit"}
              />
              <AddressContent address={node} />
            </div>
          )
        })}
      </MultiCarousel>
    </>
  )
}

const CustomRightArrow = ({ onClick }) => {
  // onMove means if dragging or swiping in progress.
  return (
    <CustomArrow
      className={carouselArrowRight}
      style={{
        left: "calc(18% + 1px) !important",
      }}
      onClick={() => onClick()}
      role="button"
      title="Afficher l'image suivante"
    >
      <span aria-hidden="true" data-direction="right"></span>
    </CustomArrow>
  )
}
const CustomLeftArrow = ({ onClick }) => {
  // onMove means if dragging or swiping in progress.
  return (
    <CustomArrow
      className={carouselArrowLeft}
      onClick={() => onClick()}
      role="button"
      title="Afficher l'image précédente"
    >
      <span aria-hidden="true" data-direction="left"></span>
    </CustomArrow>
  )
}

RenderAddresses.propTypes = {
  addressesData: PropTypes.object.isRequired,
}
CustomRightArrow.propTypes = {
  onClick: PropTypes.func,
}
CustomLeftArrow.propTypes = {
  onClick: PropTypes.func,
}

export default RenderAddresses
